
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import { FaInfoCircle } from "react-icons/fa";
import axios from 'axios';

import { useParams } from "react-router-dom"; // If using React Router
import Groceryorderplaced from "./importpage/Groceryorderplaced";


// const Ordercart = ({ orderId }) => {
const Grocerycartdata = ({ filteredDataProp = [] }) => {

    const [selectedService, setSelectedService] = React.useState(null);

    const [showPopup, setShowPopup] = useState(false);
    const [serviceApplied, setServiceApplied] = useState(true); // initially applied
    const navigate = useNavigate();
    const [orderData, setOrderData] = useState(null);
    // const [cartItems, setCartItems] = useState([]);
    const { id } = useParams(); // Get ID from URL (if using routing)

    const [loading, setLoading] = useState(false);
    const [selectedOrderType, setSelectedOrderType] = useState(null);


    const [savedDetails, setSavedDetails] = useState(null);


    const [cartItems, setCartItems] = useState([]);
    const [quantities, setQuantities] = useState({});

    const [showPaymentData, setShowPaymentData] = useState(false);

    const [displayData, setDisplayData] = useState([]);


    const [isWalletChecked, setIsWalletChecked] = useState(false);
    const [isCashChecked, setIsCashChecked] = useState(false);
    const [isOnlineChecked, setIsOnlineChecked] = useState(false);


    const vendorId = Number(localStorage.getItem("vendorId") || 42);  // Ensure vendorId is a number

    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");

    const [showWalletOptions, setShowWalletOptions] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState(""); // "online" or "cod"
    const [subTotal, setSubTotal] = useState(0);
    const [platformCharge, setPlatformCharge] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [gstData, setGstData] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
    const [gstTotal, setGstTotal] = useState(0);
    const [serviceCharges, setServiceCharges] = useState(0);
    const [gstRate, setGstRate] = useState(0);

    const [cgst, setCgst] = useState(0);
    const [sgst, setSgst] = useState(0);



    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 480);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // ✅ Fetch Cart Data on Mount
    useEffect(() => {
        const fetchCartData = async () => {
            const vendorId = localStorage.getItem("vendorId") || "1";
            const token = localStorage.getItem("authToken");

            console.log("📦 Fetching cart for vendor:", vendorId);
            setLoading(true);

            try {
                const response = await axios.get(
                    `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/cart/${vendorId}`,
                    {
                        headers: {
                            accept: "*/*",
                            ...(token ? { Authorization: `Bearer ${token}` } : {}),
                        },
                    }
                );

                console.log("✅ Cart API response:", response.data);

                const cartData =
                    Array.isArray(response.data) && response.data.length > 0
                        ? response.data[0]
                        : response.data || {};

                // ✅ Save cartId to localStorage
                if (cartData.id || cartData.cartId) {
                    const idToSave = cartData.cartId || cartData.id;
                    localStorage.setItem("cartId", idToSave);
                    console.log("🛒 Cart ID saved:", idToSave);
                }

                const items = cartData.items || [];
                if (items.length === 0) {
                    console.warn("⚠️ No items in the cart.");
                }

                // ✅ Normalize item structure
                const normalizedItems = items.map((i) => ({
                    cartItemId: i.cartItemId || i.id || i.itemId,
                    dishId: i.dishId || i.itemId,
                    itemId: i.itemId || i.dishId,
                    itemName: i.itemName || i.name || i.item?.name || "Unnamed Item",
                    itemPrice: i.itemPrice || i.price || i.item?.price || 0,
                    quantity: i.quantity ?? 1,
                    total:
                        i.total ??
                        (i.quantity ?? 1) * (i.itemPrice || i.item?.price || 0),
                }));

                // ✅ Update state
                setCartItems(normalizedItems);
                setDisplayData(normalizedItems);

                // ✅ Manage quantity persistence
                const savedQuantities =
                    JSON.parse(localStorage.getItem("cartQuantities") || "{}");
                const updatedQuantities = {};

                normalizedItems.forEach((item) => {
                    updatedQuantities[item.dishId] =
                        savedQuantities[item.dishId] ?? item.quantity ?? 1;
                });

                setQuantities(updatedQuantities);
                localStorage.setItem(
                    "cartQuantities",
                    JSON.stringify(updatedQuantities)
                );
            } catch (error) {
                console.error("❌ Error fetching cart data:", error);
                alert("Failed to load cart data: " + error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCartData();
    }, []);

    // ✅ Update Quantity (PUT API)
    const updateQuantity = async (item, newQuantity) => {
        const cartId = item?.cartId || localStorage.getItem("cartId");
        const itemId = item?.itemId || item?.dishId;
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!cartId || !itemId || !vendorId) {
            console.error("❌ Missing required IDs", { cartId, itemId, vendorId, item });
            return;
        }

        if (newQuantity < 1) {
            console.warn(`⚠️ Quantity cannot go below 1 for item ${itemId}`);
            return;
        }

        const apiUrl = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/update/cart/${vendorId}/${cartId}?itemId=${itemId}&quantity=${newQuantity}`;

        try {
            const response = await axios.put(apiUrl, null, {
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                    accept: "*/*",
                },
            });

            if (response.status === 200 || response.status === 201) {
                // ✅ Update local state
                setQuantities((prev) => {
                    const updated = { ...prev, [itemId]: newQuantity };
                    localStorage.setItem("cartQuantities", JSON.stringify(updated));
                    return updated;
                });

                setCartItems((prevItems) =>
                    prevItems.map((ci) =>
                        ci.itemId === itemId || ci.dishId === itemId
                            ? {
                                ...ci,
                                quantity: newQuantity,
                                total: parseFloat((ci.itemPrice * newQuantity).toFixed(2)),
                            }
                            : ci
                    )
                );

                setDisplayData((prevItems) =>
                    prevItems.map((ci) =>
                        ci.itemId === itemId || ci.dishId === itemId
                            ? {
                                ...ci,
                                quantity: newQuantity,
                                total: parseFloat((ci.itemPrice * newQuantity).toFixed(2)),
                            }
                            : ci
                    )
                );

                console.log(`✅ Quantity updated for item ${itemId}: ${newQuantity}`);
            } else {
                console.error("❌ Backend update failed:", response.data);
            }
        } catch (err) {
            console.error("❌ Error updating quantity:", err.response?.data || err.message);
        }
    };




    const handleCheckboxChange = (e, method, type) => {
        const isChecked = e.target.checked;
        console.log(`Checkbox for ${method} is checked: `, isChecked);

        // Reset all payment type states first
        setIsWalletChecked(false);
        setIsCashChecked(false);
        setIsOnlineChecked(false);
        setShowWalletOptions(false);

        let newSelectedMethod = "";

        if (isChecked) {
            switch (method) {
                case "wallet":
                    setIsWalletChecked(true);
                    setShowWalletOptions(true); // Show wallet options
                    newSelectedMethod = "Maamaas_Wallet";
                    break;
                case "cash":
                    setIsCashChecked(true);
                    newSelectedMethod = "Cash";
                    break;
                case "online":
                    setIsOnlineChecked(true);
                    newSelectedMethod = "Online_Payment";
                    break;
                default:
                    break;
            }
            // ✅ Set selectedPayment to the passed type when checked
            setSelectedPayment(type);
        } else {
            // Unchecking resets selectedPayment
            setSelectedPayment("");
        }

        // Update the main payment method state
        setSelectedPaymentMethod(newSelectedMethod);
        console.log("✅ Will set selectedPaymentMethod to:", newSelectedMethod);
    };

    const handleShowGST = async (vendorId) => {
        // fallback to localStorage if nothing is passed
        const currentVendorId = vendorId || localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        try {
            const response = await axios.get(
                `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes-vendor/${currentVendorId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // if required
                    },
                }
            );

            const data = response.data;
            // console.log("Fetched GST Data (Raw Response):", data);

            // ✅ Handle both array and object response cases
            const gstObj = Array.isArray(data) ? data[0] : data;

            if (gstObj) {
                const gstDetails = {
                    serviceChargeGst: gstObj.serviceChargeGst ?? 0,
                    platformChargeGst: gstObj.platformChargeGst ?? 0,
                    cgst: gstObj.cgst ?? 0,
                    sgst: gstObj.sgst ?? 0,
                    gstTotal: gstObj.gstTotal ?? 0,   // 👈 added total if you want to show
                    grandTotal: gstObj.grandTotal ?? 0,
                };

                // console.log("Extracted GST & Billing Details:", gstDetails);
                console.table(gstDetails);

                setGstData(gstDetails);
                setShowPopup(true);
            } else {
                // console.warn("No GST data found in API response.");
            }
        } catch (err) {
            // console.error("Error fetching GST data:", err);
        }
    };


    const handleCheckoutClickS = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");
        const cartId = localStorage.getItem("cartId");
        const storedCoupon = localStorage.getItem("appliedCoupon");
        const appliedCoupon = storedCoupon ? JSON.parse(storedCoupon) : null;

        if (!token || !vendorId || !cartId) {
            alert("Missing token, vendor ID, or cart ID. Please log in again.");
            return;
        }

        try {
            localStorage.removeItem("orderId"); // clear previous order

            // 🪙 CASH PAYMENT FLOW
            if (selectedPaymentMethod === "Cash") {
                try {
                    const response = await axios.post(
                        `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/orders`,
                        "", // same as -d '' in curl
                        {
                            headers: {
                                Accept: "*/*",
                                Authorization: `Bearer ${token}`,
                            },
                            params: {
                                cartId,
                                vendorId,
                                paymentMethod: "Cash",
                            },
                        }
                    );

                    // console.log("🧾 Cash Order Response:", response.data);
                    // alert("✅ Order placed successfully with Cash on Delivery!");

                    if (response.data?.orderId) {
                        localStorage.setItem("orderId", response.data.orderId);
                    }

                    navigate("/groceryaccuontdata");
                } catch (err) {
                    console.error("❌ Error creating cash order:", err);
                    alert("Failed to create cash order: " + err.message);
                }
                return;
            }

            // 💳 ONLINE PAYMENT FLOW
            if (selectedPaymentMethod === "Online_Payment") {
                const isRazorpayLoaded = await loadRazorpayScript();
                if (!isRazorpayLoaded) {
                    alert("Razorpay SDK failed to load.");
                    return;
                }

                const amountInPaise = Math.round(grandTotal * 100);
                const phoneNumber = savedDetails?.mobileNumber || "9999999999";

                // ✅ Step 1: Create Razorpay Order (Backend)
                const orderResponse = await fetch(
                    `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/payments/create-order/user`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`, // ensure valid token
                        },
                        body: JSON.stringify({
                            amount: amountInPaise,
                            currency: "INR",
                            receipt: `order_${Date.now()}`,
                            notes: {
                                customer_name: savedDetails?.name || "John Doe",
                                order_reference: `WEB_ORDER_${Math.floor(Math.random() * 10000)}`,
                            },
                        }),
                    }
                );

                if (!orderResponse.ok) {
                    const errorText = await orderResponse.text();
                    console.error("❌ Failed to create Razorpay order:", errorText);
                    alert("Failed to create Razorpay order. Check console for details.");
                    return;
                }

                const orderData = await orderResponse.json();

                // ✅ Step 2: Razorpay Checkout
                const options = {
                    key: "rzp_live_RU5whSMu9rPV7s",
                    amount: amountInPaise,
                    currency: "INR",
                    order_id: orderData.orderId,
                    name: "Maamaa's House",
                    description: "Order Payment",
                    prefill: {
                        name: savedDetails?.name || "User",
                        email: savedDetails?.email || "user@example.com",
                        contact: phoneNumber,
                    },
                    theme: { color: "#3399cc" },

                    handler: async function (response) {
                        try {
                            console.log("✅ Razorpay payment success:", response);

                            // ✅ Step 3: Capture Payment
                            const capturePayload = {
                                paymentId: response.razorpay_payment_id,
                                amount: amountInPaise,
                                currency: "INR",
                                receipt: `receipt_${Date.now()}`,
                            };

                            const captureRes = await fetch(
                                `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/payments/capture`,
                                {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${token}`,
                                    },
                                    body: JSON.stringify(capturePayload),
                                }
                            );

                            const captureData = await captureRes.json();
                            console.log("💰 Capture API response:", captureData);

                            if (!captureRes.ok || captureData.status !== "captured") {
                                alert("Payment capture failed!");
                                return;
                            }

                            // ✅ Step 4: Create Final Grocery Order
                            const orderCreateUrl = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/orders?cartId=${cartId}&vendorId=${vendorId}&paymentMethod=Online_Payment&razorpayPaymentId=${response.razorpay_payment_id}&razorpayOrderId=${orderData.orderId}&phoneNumber=${phoneNumber}`;

                            const orderCreateRes = await fetch(orderCreateUrl, {
                                method: "POST",
                                headers: {
                                    Accept: "*/*",
                                    Authorization: `Bearer ${token}`,
                                },
                                body: "", // -d '' same as cURL
                            });

                            if (orderCreateRes.ok) {
                                const result = await orderCreateRes.json();
                                // console.log("🧾 Order Created Successfully:", result);
                                // alert("✅ Payment captured & order placed successfully!");
                                localStorage.setItem("orderId", result.orderId);
                                setShowPaymentData(true);
                            } else {
                                const errorData = await orderCreateRes.text();
                                console.error("❌ Order creation failed:", errorData);
                                alert("Order creation failed after payment.");
                            }
                        } catch (err) {
                            console.error("⚠️ Payment handler error:", err);
                            alert("Something went wrong after payment.");
                        }
                    },
                };

                const paymentObject = new window.Razorpay(options);
                paymentObject.open();
            }

            // 🪙 Wallet Payment
            if (selectedPaymentMethod === "Maamaas_Wallet") {
                alert("Wallet payment integration coming soon!");
            }
        } catch (error) {
            console.error("Checkout error:", error);
            alert("Failed to proceed to checkout.");
        }
    };



    useEffect(() => {
        const flag = localStorage.getItem("showPaymentData") === "true";
        const service = localStorage.getItem("selectedService");
        const order = localStorage.getItem("orderData");

        if (flag && service && order) {
            setShowPaymentData(true);
            setSelectedService(service);
            setOrderData(JSON.parse(order));
        }

        // Optional: Clear after use
        localStorage.removeItem("showPaymentData");
        localStorage.removeItem("selectedService");
        localStorage.removeItem("orderData");
    }, []);




    React.useEffect(() => {
        const service = localStorage.getItem('selectedService');
        setSelectedService(service);
    }, []);


    useEffect(() => {
        // console.log("Updated displayData:", filteredDataProp);
        setDisplayData(filteredDataProp);
    }, [filteredDataProp]);




    useEffect(() => {
        const fetchCartData = async () => {
            const vendorId = localStorage.getItem("vendorId") || "1";
            const token = localStorage.getItem("authToken");

            console.log("Fetching cart for vendor:", vendorId);

            try {
                const response = await axios.get(
                    `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/cart/${vendorId}`,
                    {
                        headers: {
                            accept: "*/*",
                            ...(token ? { Authorization: `Bearer ${token}` } : {}),
                        },
                    }
                );

                console.log("Cart API response:", response.data);

                const cartData =
                    Array.isArray(response.data) && response.data.length > 0
                        ? response.data[0]
                        : response.data || {};

                const items = cartData.items || [];

                if (items.length === 0) {
                    console.warn("No cart items found.");
                }

                // ✅ Normalize data structure for consistent rendering
                const normalizedItems = items.map((i) => ({
                    cartItemId: i.cartItemId || i.id || i.itemId,
                    dishId: i.dishId || i.itemId,
                    itemName: i.itemName || i.name || i.item?.name || "Unnamed Item",
                    itemPrice: i.itemPrice || i.price || i.item?.price || 0,
                    quantity: i.quantity ?? 1,
                    total: i.total ?? (i.quantity ?? 1) * (i.itemPrice || i.item?.price || 0),
                }));

                // ✅ Save to state
                setCartItems(normalizedItems);
                setDisplayData(normalizedItems);

                // ✅ Load or initialize quantities
                const savedQuantities = JSON.parse(localStorage.getItem("cartQuantities") || "{}");
                const updatedQuantities = {};

                normalizedItems.forEach((item) => {
                    updatedQuantities[item.dishId] =
                        savedQuantities[item.dishId] ?? item.quantity ?? 1;
                });

                setQuantities(updatedQuantities);
                localStorage.setItem("cartQuantities", JSON.stringify(updatedQuantities));

                // ✅ Set totals from response body
                setSubTotal(cartData.subtotal || 0);
                setPlatformCharge(cartData.platformFeeAmount || 0);
                setGstTotal(cartData.gstAmount || 0);
                setGrandTotal(cartData.total || 0);
            } catch (error) {
                console.error("❌ Error fetching cart data:", error);
                alert("Failed to load cart data: " + error.message);
            }
        };

        fetchCartData();
    }, []);



    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };


    useEffect(() => {
        const storedOrderData = localStorage.getItem("orderData");
        const storedShowCheckout = localStorage.getItem("showCheckout");

        if (storedOrderData && storedShowCheckout === "true") {
            setOrderData(JSON.parse(storedOrderData));
            // setShowCheckout(true);

            // ✅ Clear `showCheckout` after showing it once
            localStorage.removeItem("showCheckout");
        }
    }, []);


    cartItems.reduce((acc, item) => ({ ...acc, [item.dishId]: item.quantity || 1 }), {})


    useEffect(() => {
        setDisplayData(cartItems);
    }, [cartItems]);



    const incrementQuantity = async (item) => {
        const cartId = item?.cartId || localStorage.getItem("cartId");
        const itemId = item?.itemId || item?.dishId; // ✅ fallback added
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!cartId || !itemId || !vendorId) {
            console.error("❌ Missing required IDs", { cartId, itemId, vendorId, item });
            return;
        }

        const currentQty = quantities[itemId] || item.quantity || 1;
        const newQuantity = currentQty + 1;
        updateQuantity(item, newQuantity);
        const apiUrl = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/update/cart/${vendorId}/${cartId}?itemId=${itemId}&quantity=${newQuantity}`;

        try {
            const response = await axios.put(apiUrl, null, {
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                    accept: "*/*",
                },
            });

            if (response.status === 200 || response.status === 201) {
                setQuantities((prev) => {
                    const updated = { ...prev, [itemId]: newQuantity };
                    localStorage.setItem("cartQuantities", JSON.stringify(updated));
                    return updated;
                });
                const itemPrice = parseFloat(item.itemPrice || item.price || item.unitPrice || 0);
                const newSubTotal = subTotal + itemPrice;
                const newGst = newSubTotal * gstRate;
                const newGrandTotal = newSubTotal + platformCharge + serviceCharges + newGst;

                setSubTotal(newSubTotal);
                setGstTotal(newGst);
                setCgst(newGst / 2);
                setSgst(newGst / 2);
                setGrandTotal(newGrandTotal);
                console.log(`✅ Quantity increased for item ${itemId}: ${newQuantity}`);
            } else {
                console.error("❌ Backend failed:", response.data);
            }
        } catch (err) {
            console.error("❌ Error updating quantity:", err.response?.data || err.message);
        }
    };



    // Decrement Function
    const decrementQuantity = async (item) => {
        const cartId = item?.cartId || localStorage.getItem("cartId");
        const itemId = item?.itemId || item?.dishId; // ✅ fallback added
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!cartId || !itemId || !vendorId) {
            console.error("❌ Missing required IDs", { cartId, itemId, vendorId, item });
            return;
        }

        const currentQty = quantities[itemId] || item.quantity || 1;
        const newQuantity = currentQty - 1;
        updateQuantity(item, newQuantity);
        const apiUrl = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/update/cart/${vendorId}/${cartId}?itemId=${itemId}&quantity=${newQuantity}`;

        try {
            const response = await axios.put(apiUrl, null, {
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                    accept: "*/*",
                },
            });

            if (response.status === 200 || response.status === 201) {
                setQuantities((prev) => {
                    const updated = { ...prev, [itemId]: newQuantity };
                    localStorage.setItem("cartQuantities", JSON.stringify(updated));
                    return updated;
                });
                const itemPrice = parseFloat(item.itemPrice || item.price || item.unitPrice || 0);
                const newSubTotal = subTotal + itemPrice;
                const newGst = newSubTotal * gstRate;
                const newGrandTotal = newSubTotal + platformCharge + serviceCharges + newGst;

                setSubTotal(newSubTotal);
                setGstTotal(newGst);
                setCgst(newGst / 2);
                setSgst(newGst / 2);
                setGrandTotal(newGrandTotal);
                console.log(`✅ Quantity increased for item ${itemId}: ${newQuantity}`);
            } else {
                console.error("❌ Backend failed:", response.data);
            }
        } catch (err) {
            console.error("❌ Error updating quantity:", err.response?.data || err.message);
        }
    };

    const handleClearCart = async () => {
        try {
            const vendorId = localStorage.getItem("vendorId");
            const authToken = localStorage.getItem("authToken");

            if (!vendorId) {
                alert("Vendor ID not found!");
                return;
            }



            if (!authToken) {
                alert("Authentication token not found!");
                return;
            }

            const response = await fetch(
                `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/clear/${vendorId}`,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${authToken}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            alert("🗑️ Cart cleared successfully!");
            setDisplayData([]); // ✅ Clear table data in UI

        } catch (error) {
            // console.error("Failed to clear cart:", error);
            alert("Failed to clear the cart. Please try again!");
        }
    };


    return (
        <div>


            {!showPaymentData ? (

                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    {/* Button Section */}

                    {/* ===================  check Out code ============================================== */}
                    <div
                        style={{
                            overflowY: isMobile ? "none" : "auto",
                            scrollbarWidth: "none",
                            marginTop: "-50px",
                            height: "550px",
                        }}
                        className="carts1 carts-scroll-datass"
                    >
                        <>
                            <div>
                                <>
                                    <style>{`
        .order-wrapper {
          display: flex;
          flex-direction: column;
        //   padding: 5px;
           background: #b15cd6;
          font-family: sans-serif;
         border-radius: 10px;
         margin-top:10px;
        }

        .order-container {
          background: #b15cd6;
          border-radius: 10px;
          color: #fff;
          padding: 15px;
          margin-bottom: 20px;
        }

        .order-heading {
          font-weight: bold;
          text-align: center;
          font-size: 22px;
          margin-bottom: 15px;
        }

        .order-table-wrapper {
          overflow-x: auto;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 15px;
          font-weight: bold;
        }

        th, td {
          padding: 10px;
          border-bottom: 1px solid #fff;
          text-align: center;
          font-size: 18px;
        }


@media (max-width: 480px) {
  th, td {
    font-size: 10px;
  }
}


        .quantity-box {
          display: flex;
          align-items: center;
          background: #fff;
          border-radius: 10px;
          width: 80px;
          margin: auto;
        }

        .quantity-box button {
          border: none;
          background: transparent;
          padding: 5px;
          cursor: pointer;
          color: #000;
          font-weight: bold;
          font-size:16px;
        }

        .quantity-box span {
          padding: 0 10px;
          font-weight: 800;
          color: #000;
        }

        .no-data {
          text-align: center;
          padding: 20px;
          font-weight: bold;
        }

        .total-section {
          background: #b15cd6;
          border-radius: 10px;
          padding: 20px;
          color: white;
        }

        .pricedetails {
          display: flex;
        //   align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
        //   flex-wrap: wrap;
        }

        .pricedetails dt,
        .pricedetails dd {
          margin: 0;
          font-size:19px;
        }

        .pricedetails dd {
          min-width: 50px;
          text-align: right;
        }

        .total-button {
          padding: 4px 10px;
          width: 85px;
          height: 35px;
          cursor: pointer;
          border: none;
          border-radius: 10px;
          color: white;
          font-weight: bold;
        }

        hr {
          border: 2px solid #000 !important;
          margin: 15px 0;
        }

        @media (max-width: 1200px) {
          .pricedetails {
            // flex-direction: column;
            align-items: flex-start;
          }
        }

        @media (max-width: 768px) {
          .pricedetails {
            // flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>

                                    <div className="order-wrapper">
                                        {/* Order Items Table */}
                                        <div className="order-container">
                                            <div style={{ position: "relative", textAlign: "center", marginBottom: "16px" }}>
                                                <h4 style={{ margin: 0, fontSize: "22px", fontWeight: "600" }}>Review your Cart</h4>
                                                <button
                                                    onClick={() => handleClearCart(localStorage.getItem("cartId"))}
                                                    style={{
                                                        position: "absolute",
                                                        right: "0",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        color: "red",
                                                        background: "#fff",
                                                        border: "none",
                                                        borderRadius: "4px",
                                                        cursor: "pointer",
                                                        fontSize: "18px",
                                                    }}
                                                >
                                                    Clear All
                                                </button>



                                            </div>


                                            <div className="order-table-wrapper">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>S.NO</th>
                                                            <th>ITEM</th>
                                                            <th>QUANTITY</th>
                                                            <th>PRICE</th>
                                                            <th>TOTAL</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {displayData.length > 0 ? (
                                                            displayData
                                                                .filter(
                                                                    (item) =>
                                                                        (quantities[item.itemId] ?? item.quantity ?? 1) > 0 // ✅ changed dishId → itemId
                                                                )
                                                                .map((item, index) => (
                                                                    <tr
                                                                        key={item.id} // ✅ changed cartItemId → id
                                                                        style={{ textAlign: "center", verticalAlign: "middle" }}
                                                                    >
                                                                        <td>{index + 1}</td>
                                                                        <td style={{ fontWeight: "bold" }}>{item.itemName}</td>
                                                                        <td>
                                                                            <div className="quantity-box">
                                                                                <button
                                                                                    className="qty-btn"
                                                                                    onClick={() => decrementQuantity(item)}
                                                                                >
                                                                                    -
                                                                                </button>
                                                                                <span className="qty-value">
                                                                                    {quantities[item.itemId] ?? item.quantity ?? 1} {/* ✅ fixed quantity */}
                                                                                </span>
                                                                                <button
                                                                                    className="qty-btn"
                                                                                    onClick={() => incrementQuantity(item)}
                                                                                >
                                                                                    +
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                        <td>₹{item.itemPrice}</td>
                                                                        <td>₹{item.total?.toFixed(2)}</td> {/* ✅ changed total → itemTotal */}
                                                                    </tr>
                                                                ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="no-data">
                                                                    No data available
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>


                                                </table>
                                            </div>
                                        </div>
                                        <hr />
                                        {/* Total Pricing Summary */}
                                        <div className="total-section">
                                            <dl>
                                                <div className="pricedetails">
                                                    <dt>Sub Total</dt>
                                                    <dd>₹{subTotal.toFixed(2)}</dd>
                                                </div>

                                                <div className="pricedetails">
                                                    <dt>Platform Charges</dt>
                                                    <dd>₹{platformCharge.toFixed(2)}</dd>
                                                </div>

                                                <div className="pricedetails">
                                                    <dt
                                                        onClick={() => {
                                                            const cartId = localStorage.getItem("cartId");
                                                            setServiceApplied(!serviceApplied);
                                                            if (!serviceApplied) {
                                                                setServiceCharges(10); // Example: ₹10 when applied
                                                                setGrandTotal((prev) => prev + 10);
                                                            } else {
                                                                setGrandTotal((prev) => prev - 10);
                                                                setServiceCharges(0);
                                                            }
                                                        }}
                                                        style={{
                                                            cursor: "pointer",
                                                            padding: "4px 8px",
                                                            borderRadius: "5px",
                                                            border: "1px solid #ccc",
                                                            background: "rgb(242, 242, 242)",
                                                            fontWeight: "bold",
                                                            color: "#000",
                                                            fontSize: "15px",
                                                        }}
                                                    >
                                                        Service Charges {serviceApplied ? "(Remove)" : "(Apply)"}
                                                    </dt>

                                                    <dd>₹{serviceCharges}</dd>
                                                </div>

                                                <div className="pricedetails">
                                                    <dt>
                                                        GST
                                                        <FaInfoCircle
                                                            style={{ marginLeft: "8px", cursor: "pointer", color: "rgb(0 187 90)" }}
                                                            onClick={() => handleShowGST(vendorId)}
                                                        />
                                                    </dt>
                                                    <dd>₹{gstTotal}</dd>
                                                </div>

                                                <hr />

                                                <div className="pricedetails" style={{ fontSize: "18px", fontWeight: "bold" }}>
                                                    <dt>Grand Total</dt>
                                                    <dd>₹{grandTotal.toFixed(2)}</dd>
                                                </div>
                                            </dl>
                                        </div>

                                    </div>
                                </>
                            </div>


                            {/* Internal CSS */}
                            <style>{`
        .payment-container {
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }

        .primary-btn {
            padding: 10px 20px;
            background-color: #b15dc6;
            color: #fff;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            width: 150px;
            font-weight: bold;
            font-size: 20px;
        }

        .payment-options {
            margin-top: 20px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 30px;
        }

        .payment-options button {
            padding: 10px 20px;
            border: none;
            border-radius: 5px;
            width: 140px;
            font-weight: bold;
            font-size: 20px;
            cursor: pointer;
        }

        .pay-now {
            background-color: #4CAF50;
            color: #fff;
        }

        .pay-later {
            background-color: #f44336;
            color: #fff;
        }

        .method-box-container {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 20px;
            margin-top: 40px;
        }

        .method-box {
            flex: 1;
            min-width: 250px;
            max-width: 30%;
            
            background: rgb(177, 93, 198);
            border-radius: 10px;
            display: flex;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
        }

        .method-box input[type="checkbox"] {
            transform: scale(1.5);
            cursor: pointer;
        }

        .method-box h3 {
            margin-left: 15px;
            color: #fff;
            font-weight: bold;
            font-size: 18px;
        }

        .wallet-balance-btn {
            margin-left: auto;
            background: #fff;
            border: none;
            border-radius: 10px;
            font-weight: bold;
            padding: 8px 16px;
        }

        .checkout-container {
            display: flex;
            justify-content: center;
        }

        .checkout-btn {
            height: 40px;
            border: none;
            border-radius: 10px;
            background: #b15cd6;
            color: #fff;
            font-weight: bold;
            font-size: large;
            margin-top: 10px;
            margin-bottom: 20px;
            padding: 0 30px;
        }

        /* Responsive for smaller screens */
        @media (max-width: 768px) {
            .method-box {
                max-width: 100%;
            }

            .payment-options {
                flex-direction: column;
                align-items: center;
                gap: 15px;
            }
        }
    `}</style>




                        </>


                        <style>{`
      

        .payment-box {
            flex: 1;
            min-width: 250px;
            max-width: 30%;
            height: 60px;
            background: rgb(177, 93, 198);
            border-radius: 10px;
            display: flex;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
        }

        .payment-box input[type="checkbox"] {
            transform: scale(1.5);
            cursor: pointer;
        }

        .payment-box h3 {
            margin-left: 15px;
            color: #fff;
            font-weight: bold;
            font-size: 18px;
        }

        .wallet-amount-btn {
            margin-left: auto;
            background: #fff;
            border: none;
            border-radius: 10px;
            font-weight: bold;
            padding: 8px 16px;
        }

        .checkout-wrapper {
            display: flex;
            justify-content: center;
        }

        .checkout-btn {
            height: 40px;
            border: none;
            border-radius: 10px;
            background: #b15cd6;
            color: #fff;
            font-weight: bold;
            font-size: large;
            margin-top: -30px;
            margin-bottom: 20px;
            padding: 0 30px;
        }

        @media (max-width: 968px) {
          
                  .payment-row {
            display: flex;
            justify-content: center;
            gap: 20px;
       
            flex-wrap: wrap;
        }
        }
          @media (min-width: 968px) {
       
                  .payment-row {
            display: flex;
            justify-content: center;
            gap: 20px;
       margin-top: 40px !important;
            flex-wrap: wrap;
        }
        }
    `}</style>

                        <div className="row">
                            <div
                                style={{

                                    background: 'rgb(24, 157, 62)',
                                    borderRadius: '25px',
                                    color: '#fff',

                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}
                            >
                            </div>

                        </div>

                        {selectedOrderType !== "Dine In" && (
                            <div className="payment-row">
                                {/* Wallet */}


                                {/* Cash */}
                                <div className="payment-box">
                                    <input
                                        type="checkbox"
                                        onChange={(e) => handleCheckboxChange(e, "cash")}
                                        checked={isCashChecked}
                                    />
                                    <h3>Cash</h3>
                                </div>

                                <div>
                                    <div className="payment-box">
                                        <input
                                            type="checkbox"
                                            onChange={(e) => handleCheckboxChange(e, "online", "online")}
                                            checked={selectedPayment === "online"}
                                        />
                                        <h3>Online Payment</h3>
                                    </div>

                                    {/* Conditionally render phone number input */}
                                    {selectedPayment === "online" && (
                                        <div
                                            className="phone-input-box"
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                margin: "10px 0",
                                            }}
                                        >
                                            <input
                                                type="text"
                                                id="phoneNumber"
                                                name="phoneNumber"
                                                value={phoneNumber}
                                                onChange={(e) => setPhoneNumber(e.target.value)}
                                                placeholder="Enter phone number"
                                                style={{
                                                    width: "250px",
                                                    padding: "10px 15px",
                                                    borderRadius: "8px",
                                                    border: "1px solid #ccc",
                                                    outline: "none",
                                                    fontSize: "16px",
                                                    transition: "0.3s",
                                                }}
                                                onFocus={(e) => (e.target.style.borderColor = "#b15cd6")}
                                                onBlur={(e) => (e.target.style.borderColor = "#ccc")}
                                            />
                                        </div>

                                    )}
                                </div>

                            </div>
                        )}
                        <div className="checkout-wrapper" style={{ marginTop: "50px" }}>
                            <button className="checkout-btn" onClick={handleCheckoutClickS}>
                                Procced to CheckOut
                            </button>
                        </div>

                    </div >






                    {/* ===================================== GST POP UP DATA =============================================================== */}


                    {showPopup && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: "rgba(0, 0, 0, 0.6)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 999,
                                animation: "fadeIn 0.3s ease-in-out",
                            }}
                        >
                            <div
                                style={{
                                    background: "linear-gradient(135deg, #ffffff, #f8f9fa)",
                                    padding: "25px",
                                    borderRadius: "12px",
                                    width: "350px",
                                    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                                    textAlign: "center",
                                    animation: "scaleUp 0.3s ease-in-out",
                                }}
                            >
                                <h3 style={{ marginBottom: "15px", color: "#333", fontSize: "20px" }}>
                                    GST Breakdown
                                </h3>

                                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>Service Charge GST:</strong> ₹{gstData.serviceChargeGst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>Platform Charge GST:</strong> ₹{gstData.platformChargeGst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>CGST:</strong> ₹{gstData.cgst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>SGST:</strong> ₹{gstData.
                                            sgst
                                        }
                                    </li>
                                </ul>

                                <button
                                    onClick={() => setShowPopup(false)}
                                    style={{
                                        marginTop: "20px",
                                        padding: "10px 18px",
                                        background: "linear-gradient(90deg, #007bff, #0056d2)",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                    }}
                                    onMouseOver={(e) =>
                                    (e.target.style.background =
                                        "linear-gradient(90deg, #0056d2, #003c99)")
                                    }
                                    onMouseOut={(e) =>
                                    (e.target.style.background =
                                        "linear-gradient(90deg, #007bff, #0056d2)")
                                    }
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}



                </div >
            ) : (
                <Groceryorderplaced />
            )
            }

        </div >

    );
};

export default Grocerycartdata;










